import pipwerks from 'pipwerks-scorm-api-wrapper';

class ScormAPI {
  constructor() {
    this.api = pipwerks.SCORM;
    this.api.version = '1.2';
  }

  initialize() {
    return this.api.init();
  }

  terminate() {
    return this.api.quit();
  }

  setValue(cmiElement, value) {
    return this.api.set(cmiElement, value);
  }

  getValue(cmiElement) {
    return this.api.get(cmiElement);
  }


  initializeWithDefaults() {
    if (this.initialize()) {
      console.log('SCORM API initialized');
      this.setValue('cmi.core.lesson_status', 'incomplete');
      return true;
    } else {
      console.error('Failed to initialize SCORM API');
      return false;
    }
  }

  // commit(){ 
  //   return this.api.commit();
  // }

  commit() {
    if (this.api && this.api.connection.isActive) {
      console.log("Committing data...");
      return this.api.save();
    } else {
      console.error("SCORM commit failed: API is inactive or undefined");
      return false;
    }
  }



  
  // Salva o progresso do aluno
  saveProgress(status, location) {
    try {
      this.setValue("cmi.core.lesson_status", status); // Exemplo: "completed", "incomplete", "passed", etc.
      this.setValue("cmi.core.lesson_location", location); // Salva a posição onde o aluno parou
      console.log(`Progress saved: status = ${status}, location = ${location}`);
      return true;
    } catch (error) {
      console.error('Error saving progress:', error);
      return false;
    }
  }

  // Recupera o progresso do aluno
  getProgress() {
    try {
      const status = this.getValue("cmi.core.lesson_status");
      const location = this.getValue("cmi.core.lesson_location");
      console.log(`Progress retrieved: status = ${status}, location = ${location}`);
      return { status, location };
    } catch (error) {
      console.error('Error retrieving progress:', error);
      return { status: null, location: null };
    }
  }

  // Salva dados complementares no localStorage
  saveLocalData({ userid, projeto, action = 'home', actionModulo = 0, completed = false, extra = {} }) {
    try {
      const progress = this.getProgress(); // status e location via SCORM
      const dados = {
        userid,
        projeto,
        action,
        actionModulo,
        completed,
        status: progress.status,
        location: progress.location,
        ...extra // permite incluir dados personalizados
      };

      // Pega projetos já existentes
      const existing = JSON.parse(localStorage.getItem("project")) || [];

      // Atualiza ou adiciona
      const updated = [...existing.filter(p => p.userid !== userid || p.projeto !== projeto), dados];

      // Salva no localStorage
      localStorage.setItem("project", JSON.stringify(updated));

      console.log("LocalStorage saved:", dados);
      return dados;
    } catch (error) {
      console.error("Erro ao salvar no localStorage:", error);
      return null;
    }
  }

// EXEMPLO DE COMO CHAMAR A FUNÇÃO PARA SALVAR OS DADOS NO LOCALSTORAGE  
//   scormAPI.saveLocalData({
//   userid: "user123",
//   projeto: "cursoA",
//   completed: false,
//   extra: {
//     sectionCheck: ["intro", "mod1"],
//     controllArticle: { "intro": true },
//     customNote: "Avançando bem no conteúdo"
//   }
// });

  // Atualiza o progresso enquanto o aluno avança
  updateProgress(status, location) {
    try {
      // Atualiza o status (ex: "incomplete" -> "completed")
      this.setValue("cmi.core.lesson_status", status);
      // Atualiza a localização (ex: índice da página ou seção)
      this.setValue("cmi.core.lesson_location", location);
      console.log(`Progress updated: status = ${status}, location = ${location}`);
      return true;
    } catch (error) {
      console.error('Error updating progress:', error);
      return false;
    }
  }

}

const scormAPI = new ScormAPI();
export default scormAPI;